import { baselineOrder, initSelection, pinSelectedFirst, SelectionPage } from "./meta_ads/selection";

const idOf = (row: HTMLElement) => row.dataset.adsetId;

function firstNumber(rows: HTMLElement[], tbody: HTMLElement): number {
  if (tbody.dataset.firstNumber === undefined) {
    const first = rows[0]?.querySelector(".g-num")?.textContent;
    tbody.dataset.firstNumber = String(parseInt(first || "1", 10) || 1);
  }

  return Number(tbody.dataset.firstNumber);
}

function reorder(ids: string[]): void {
  const tbody = document.querySelector<HTMLElement>(".arf-page table.grid tbody");
  if (!tbody) return;

  const rows = baselineOrder(Array.from(tbody.querySelectorAll<HTMLElement>("tr[data-adset-id]")));
  const start = firstNumber(rows, tbody);

  pinSelectedFirst(tbody, rows, ids, idOf).forEach((row, index) => {
    const cell = row.querySelector(".g-num");
    if (cell) cell.textContent = String(start + index);
  });
}

function summarise(ids: string[]): void {
  const readout = document.getElementById("arf-adset-selected");
  if (!readout) return;

  const count = document.getElementById("arf-adset-selected-count");
  const unit = document.getElementById("arf-adset-selected-unit");
  if (count) count.textContent = String(ids.length);
  if (unit) unit.textContent = ids.length === 1 ? "ad set" : "ad sets";

  readout.classList.toggle("d-none", ids.length === 0);
}

const AD_SETS: SelectionPage = {
  param: "selected_adset_ids",
  root: "[data-adset-selection]",
  item: "tr[data-adset-id]",
  toggle: ".g-check",
  idOf,
  // The tab strip, the page body (table, pager) and the header search.
  containers: [".arf-tabs", ".arf-page", ".meta-ad-search-bar"],

  paint: (row, selected) => {
    row.classList.toggle("selected", selected);

    const box = row.querySelector<HTMLInputElement>('input[type="checkbox"]');
    // The click is prevented on the wrapping link, which also cancels the
    // checkbox's own toggle, so its state is set here instead.
    if (box) box.checked = selected;

    const toggle = row.querySelector(".g-check");
    if (toggle) toggle.setAttribute("title", selected ? "Deselect" : "Select for Ads tab");
  },

  reflect: (ids) => {
    reorder(ids);
    summarise(ids);
  },
};

export function initAdSetSelection(): void {
  initSelection(AD_SETS);
}
